export default __webpack_public_path__ + "static/media/CERTIFICATE_4_QR.364795be.pdf";